import { render } from "./Submit.vue?vue&type=template&id=672c5b5c"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"
script.render = render

export default script